<div class="flex flex-column pt-3" [formGroup]="autopayPaperlessPaymentForm">
  <div class="flex flex-column justify-content-between p-3 gap-3 accordion-view">
    <div class="flex justify-content-between align-items-center gap-3 cursor-pointer" (click)="toggleAccordion()">
      <div class="flex justify-content-between">
        <i [ngClass]="{'pi-chevron-down': !flowTypeAccordion, 'pi-chevron-up': flowTypeAccordion}"
        class="pi mr-2" style="font-size: 1rem"></i>
        <span class="text-lg font-semibold">

          @if (orderFlowType  === OrderFlowType.Internet) {
            <ng-container *ngTemplateOutlet="internetTitle"></ng-container>
          } @else if (orderFlowType  === OrderFlowType.Wireless) {
            <app-translate key="ATT_WIRELESS"></app-translate>
          } @else if (orderFlowType === OrderFlowType.Video) {
            <app-translate key="ATT_VIDEO"></app-translate>
          }


          <ng-template #internetTitle>
            @if (providerType?.toLowerCase() === OOFProvidersEnum.VIASAT    ) {
              <app-translate key="VIASAT"></app-translate>
            } @else {
              <app-translate key="ATT_INTERNET"></app-translate>
            }
          </ng-template>
        </span>
      </div>
      <div class="flex">
        @if (autopayEnrollementValid) {
          <p-badge [value]="languageService.getTranslation('COMPLETE')" severity="success" class="ml-auto mr-2" />
        } @else {
          <p-badge [value]="languageService.getTranslation('INCOMPLETE')" severity="danger"
            class="ml-auto mr-2" />
        }
      </div>
    </div>
    <div class="flex flex-column gap-2 text-sm font-normal">
      @if (!hidePaperless) {
        <div class="flex align-items-center gap-1 font-italic pb-1">
          <i class="pi pi-bundle-green-check-small" style="width: 24px; height: 24px;"></i>
          <span><app-translate key="PAPERLESS"></app-translate> - <span class="font-bold"><app-translate
        key="ENROLLED"></app-translate></span></span>
      </div>
    }
    <div class="flex align-items-center gap-1 font-italic">
      @if (!autopayPaperlessPaymentForm.get('autopayEnrollment')?.value) {
        <i class="pi pi-bundle-red-x" style="width: 24px; height: 24px;"></i>
        <span><app-translate key="AUTOPAY"></app-translate> - <span class="font-bold"><app-translate
      key="DECLINED"></app-translate></span></span>
    } @else if (autopayEnrollementValid) {
      <i class="pi pi-bundle-green-check-small" style="width: 24px; height: 24px;"></i>
      <span><app-translate key="AUTOPAY"></app-translate> - <span class="font-bold"><app-translate
    key="ENROLLED"></app-translate></span></span>
  } @else {
    <i class="pi pi-bundle-exclamation-yellow" style="width: 24px; height: 24px;"></i>
    <span><app-translate key="AUTOPAY"></app-translate> - <span class="font-bold">
    @if (isOofAutopay) {
      <app-translate key="INCOMPLETE"></app-translate>
    } @else {
      <app-translate key="ENROLLED"></app-translate>
    }
  </span></span>
}
</div>
</div>
</div>

@if (flowTypeAccordion) {
  <div class="flex flex-column p-3 pt-4 accordion-content">
    @if (!isOofAutopay) {
      <div class="flex flex-column justify-content-between gap-3 mb-4">
        <div class="flex flex-column gap-1">
          <div class="flex align-items-center gap-1">
            <span class="text-base font-semibold"><app-translate
            key="AUTOPAY_PAPERLESS_BILLING"></app-translate></span>
          </div>
          <div class="flex align-items-center gap-1">
            <span class="text-base font-normal">
              <app-translate key="AGREE_TERMS_FOR_DISCOUNT"></app-translate>
            </span>
          </div>
        </div>
      </div>
    }
    @if (!hidePaperless) {
      <div class="flex flex-column justify-content-between gap-3">
        <div class="flex flex-column mt-2">
          <div class="flex flex-column">
            <div class="flex justify-content-between gap-1">
              <div class="flex flex-column">
                <span class="text-base font-semibold"><app-translate
                key="PAPERLESS_BILLING_DISCLOSURES"></app-translate></span>
                @if (paperlessEnrollmentTermsUrl) {
                  <p-button
                    [label]="languageService.getTranslation('READ_TERMS_CONDITIONS')"
                    icon="pi pi-external-link" iconPos="right" [link]="true"
                    styleClass="outline-none px-0 text-base font-semibold"
                  (onClick)="openPaperlessBillingTerms()"></p-button>
                }
              </div>
              <p-toggleswitch formControlName="paperlessEnrollment"
              [ngClass]="{'disabled-content': true}"></p-toggleswitch>
            </div>
            <div class="flex gap-2 pt-2">
              <p-checkbox [inputId]="orderFlowType + 'terms'" formControlName="paperlessEnrollmentTerms" [binary]="true"
                [ngClass]="{'disabled-content': true}">
              </p-checkbox>
              <label for="{{orderFlowType}}terms" class="font-normal text-sm" [ngClass]="{'disabled-content': true}"
                [innerHTML]="paperlessConsentHtml || languageService.getTranslation('AGREE_PAPERLESS_BILLING')">
              </label>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="flex flex-column justify-content-between gap-3">
      <div class="flex flex-column" [ngClass]="{'mt-4': !isOofAutopay}">
        <div class="flex flex-column">
          <div class="flex justify-content-between gap-1">
            <div class="flex flex-column">
              <div class="flex align-items-center gap-2">
                <span class="text-base font-semibold"><app-translate
                key="AUTOPAY_ENROLLMENT"></app-translate></span>
                @if (isOofAutopay) {
                  <i class="pi pi-info-circle cursor-pointer text-primary"
                  (click)="autopayOptOutDetails.toggle($event)"></i>
                  <p-popover #autopayOptOutDetails    styleClass="w-18rem border-round-lg"
                    appendTo="body" my="top left" at="bottom left">
                    <div class="p-3">
                      <div class="flex justify-content-between align-items-center mb-2">
                        <h3 class="m-0"><app-translate key="WANT_TO_OPT_OUT"></app-translate></h3>
                        <i class="pi pi-times cursor-pointer" (click)="autopayOptOutDetails.hide()"></i>
                      </div>
                      <p class="m-0">
                        <app-translate key="AUTOPAY_OPT_OUT_DESCRIPTION"></app-translate>
                      </p>
                    </div>
                  </p-popover>
                }
              </div>
              @if (!isOofAutopay && autopayEnrollmentTermsUrl) {
                <p-button
                  [label]="languageService.getTranslation('READ_TERMS_CONDITIONS')"
                  icon="pi pi-external-link" iconPos="right" [link]="true" styleClass="outline-none px-0"
                (onClick)="openAutoPayTerms()"></p-button>
              }
            </div>
            <div class="flex" [ngClass]="{'disabled-content': lockAutopayToggle}">
              <p-toggleswitch formControlName="autopayEnrollment"
              (ngModelChange)="autopayEnrollmentChange($event)"></p-toggleswitch>
            </div>
          </div>
          @if (isOofAutopay && autopayTermsHtml) {
            <div class="border-1 border-round-lg bg-white p-3 mt-3 mb-3">
              <div class="flex justify-content-between align-items-center cursor-pointer select-none"
                (click)="toggleAutopayTerms()">
                <span class="font-semibold"><app-translate key="AUTOPAY_TERMS_AND_CONDITIONS"></app-translate></span>
                <i class="pi"
                [ngClass]="{'pi-chevron-up': autopayTermsExpanded, 'pi-chevron-down': !autopayTermsExpanded}"></i>
              </div>
              @if (autopayTermsExpanded) {
                <div class="mt-2 overflow-y-auto text-sm text-700" style="max-height: 12rem;"
                [innerHTML]="autopayTermsHtml"></div>
              }
            </div>
          }
          <div class="flex gap-2 pt-2">
            <p-checkbox formControlName="autopayEnrollmentTerms" [binary]="true"
              [ngClass]="{'disabled-content': !autopayPaperlessPaymentForm.get('autopayEnrollment')?.value }"
              [inputId]="orderFlowType + 'autopayterms'"
              [disabled]="!autopayPaperlessPaymentForm.get('autopayEnrollment')?.value">
            </p-checkbox>
            <label for="{{orderFlowType}}autopayterms" class="font-normal text-sm"
              [ngClass]="{'disabled-content': !autopayPaperlessPaymentForm.get('autopayEnrollment')?.value }"
              [innerHTML]="autopayConsentHtml || languageService.getTranslation(isOofAutopay ? 'OOF_AUTOPAY_CONSENT' : 'AGREE_AUTOPAY_TERMS')">
            </label>
          </div>
        </div>
      </div>
    </div>
    @if (autopayPaperlessPaymentForm.get('autopayEnrollment')?.value && autopayPaperlessPaymentForm.get('autopayEnrollmentTerms')?.value) {
      <div class="flex flex-column mt-5"
        >
        @if (isOofAutopay) {
          <p-divider></p-divider>
        }
        <div class="flex flex-column gap-3 mb-3">
          <div class="flex flex-column gap-1">
            <div class="flex align-items-center gap-1">
              <span class="text-base font-semibold">
                @if (isOofAutopay) {
                  <app-translate key="RESIDENTIAL_SATELLITE_AUTOPAY_INFORMATION"></app-translate>
                } @else {
                  <app-translate key="AUTOPAY_INFORMATION"></app-translate>
                }
              </span>
            </div>
          </div>
          @if (paymentAllowAch) {
            <div class="flex flex-column gap-3">
              <div class="flex align-items-center gap-2">
                <span class="font-light text-sm"><app-translate key="PAY_WITH_ACH"></app-translate></span>
                <p-toggleswitch formControlName="payWithAch"></p-toggleswitch>
              </div>
              <div class="font-light text-sm">
                <app-translate key="LAST_NAME_MATCHING_REQUIREMENT"></app-translate>
              </div>
            </div>
          }
        </div>
        @if (!autopayPaperlessPaymentForm.get('payWithAch')?.value) {
          <div class="flex flex-column">
            @if (todaysChargesApplicable) {
              <div class="mb-4 flex gap-2 pl-2 align-items-center">
                <p-checkbox formControlName="samePaymentMethod"
                  [ngClass]="{'disabled-content': !todaysChargesApplicable}" [binary]="true"
                  [inputId]="orderFlowType + 'samePaymentMethod'" [disabled]="!todaysChargesApplicable">
                </p-checkbox>
                <label for="{{orderFlowType}}samePaymentMethod" class="font-normal text-sm"
                  [ngClass]="{'disabled-content': !todaysChargesApplicable}">
                  @if (isOofAutopay) {
                    <app-translate key="USE_SAME_PAYMENT_AS_TODAYS_CHARGES"></app-translate>
                  } @else {
                    <app-translate key="USE_SAME_PAYMENT_INFO"></app-translate>
                  }
                </label>
              </div>
            }
            @if (!autopayPaperlessPaymentForm.get('samePaymentMethod')?.value) {
              <div class="flex">
                <app-credit-card-billing [customerName]="customerName" #autopayCreditCardBilling></app-credit-card-billing>
              </div>
            }
          </div>
        }
        @if (autopayPaperlessPaymentForm.get('payWithAch')?.value) {
          <div class="flex flex-column gap-2">
            <div class="flex">
              <app-ach-billing #autopayAchBilling></app-ach-billing>
            </div>
          </div>
        }
      </div>
    }
  </div>
}
</div>
